import { ENABLE_INSIDER_AUS_CAN_M2_RETAILERS_LAUNCH_240910 } from "@faire/web-api/indigofair/settings/ENABLE_INSIDER_AUS_CAN_M2_RETAILERS_LAUNCH_240910";

import { useSetting } from "@faire/retailer/settings/__internal__/useSetting";

export const useSettingEnableInsiderAUSCANLaunch = (): boolean =>
  useSetting(ENABLE_INSIDER_AUS_CAN_M2_RETAILERS_LAUNCH_240910, false);
